import { useRetryPaymentGroup } from '@/modules/payment-groups/hooks/use-payment-group-mutations';
import { PaymentPayMethod } from '@/types/payment';
import { IPaymentGroup } from '@/types/payment-groups';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';

export function usePaymentRetry() {
  const [paymentGroupToRetry, setPaymentGroupToRetry] =
    useState<IPaymentGroup | null>(null);
  const { mutateAsync: retryPayment } = useRetryPaymentGroup();

  const handleRetryPayment = async (
    paymentGroupId: string,
    paymentMethod?: PaymentPayMethod,
  ) => {
    try {
      const { data: newPaymentGroup } = await retryPayment({
        paymentGroupId,
        paymentMethod,
      });

      if (!newPaymentGroup.providerInfo?.checkoutSessionUrl) {
        throw new Error('No checkout session URL found');
      }

      window.open(newPaymentGroup.providerInfo.checkoutSessionUrl, '_blank');
    } catch {
      enqueueSnackbar(`Failed to retry payment: ${paymentGroupId}`, {
        variant: 'error',
      });
    }
  };

  const closeRetryModal = () => {
    setPaymentGroupToRetry(null);
  };

  return {
    paymentGroupToRetry,
    setPaymentGroupToRetry,
    handleRetryPayment,
    closeRetryModal,
  };
}
